"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
class NoteInitializer extends AbstractInitializer_1.default {
    constructor(cache, noteModel, customerRepository) {
        super("note_initializer", cache);
        this.initialize = async () => {
            const notes = {};
            const customers = await this.customerRepository.getCustomers();
            customers.forEach(({ id, firstName, lastName }) => {
                notes[id] = {
                    body: `Note about ${firstName} ${lastName}`,
                };
            });
            await this.noteModel.setNotes(notes);
        };
        this.noteModel = noteModel;
        this.customerRepository = customerRepository;
    }
}
exports.default = NoteInitializer;
//# sourceMappingURL=NoteInitializer.js.map